/**
 * Check if two dates are the same day.
 * @param {Date} d1 - Date - The first date to compare
 * @param {Date} d2 - Date - The date to compare to.
 * @returns the value of the variable x.
 */
export function checkIsSameDays(d1: Date, d2: Date): boolean {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}
